import * as type from './types'
import { parseDateString } from './helpers'
import { RichText, ListItems, Image } from '../classes'

// reduce response result object to a simple model
const reduce = {
  content(content) {
    let reduced = {}

    // call appropriate method for each field by type
    Object.keys(content).forEach(prop => {
      reduced[prop] = reduce.type[content[prop].type](content[prop])
    })

    return reduced
  },
  type: {
    [type.GROUP] ({ value }) {
      return value.map(reduce.content)
    },
    [type.TEXT] ({ value }) {
      return value
    },
    [type.SELECT] ({ value }) {
      return value
    },
    [type.LINK] ({ value }) {
      return value.url
    },
    [type.PATH] ({ value }) {
      return value.document.uid || value.document.id
    },
    [type.DATETIME] ({ value }) {
      return parseDateString(value)
    },
    [type.IMAGE] ({ value }) {
      // extract image meta
      let { url, alt } = value.main
      let crops = {}

      Object.keys(value.views).forEach(crop => {
        crops[crop] = value.views[crop].url
      })

      return { url, alt, crops }
    },
    [type.RTE] ({ value }) {
      let list = null
      let elements = []
      let next = 0

      value.forEach(content => {
        next++
        switch (true) {
          case /image/.test(content.type):
            let img = new Image({ component: 'content-image', content })
            elements.push(img.parse().reduce())
            break

          case /paragraph/.test(content.type):
            let p = new RichText({ component: 'content-text', tag: 'p', content })
            elements.push(p.parse().reduce())
            break

          case /heading/.test(content.type):
            let level = content.type.match(/\d/)[0]
            let h = new RichText({ component: 'content-text', tag: `h${level}`, content })
            elements.push(h.parse().reduce())
            break

          case /list-item/.test(content.type):
            if (!list) {
              list = new ListItems({ component: 'content-list', content: [] })
            }

            list.add(content)

            if (next === value.length || value[next].type !== 'list-item') {
              elements.push(list.reduce())
              list = null
            }

            break

          default: console.error('Could not parse content:', content)
        }
      })

      return elements
    }
  }
}

export { reduce as default }



// WEBPACK FOOTER //
// ./src/api/utils/reducers.js